import React from 'react';

const LogoSvg = ({ width = 70, className = '' }) => (
  <svg
    width={width}
    height={width * 0.7}
    viewBox="0 0 220 154"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Nang Myintzu"
  >
    {/* Top-right corner bracket */}
    <path d="M216 4 L216 100" stroke="#C9A96E" strokeWidth="7" strokeLinecap="square" />
    <path d="M216 4 L120 4" stroke="#C9A96E" strokeWidth="7" strokeLinecap="square" />
    {/* Bottom-left corner bracket */}
    <path d="M3 150 L4 70" stroke="#C9A96E" strokeWidth="7" strokeLinecap="square" />
    <path d="M3 150 L70 150" stroke="#C9A96E" strokeWidth="7" strokeLinecap="square" />
    {/* NMZ text */}
    <text x="110" y="100" textAnchor="middle" fill="#F5F0EB" fontFamily="Inter,system-ui,sans-serif" fontWeight="800" fontSize="72" letterSpacing="3">NMZ</text>
    {/* Copyright */}
    <text x="184" y="32" fill="#C9A96E" fontFamily="Inter,system-ui,sans-serif" fontWeight="600" fontSize="24">©</text>
  </svg>
);

export default LogoSvg;
